export const ConsumerPhoneValidationResendCodeErrorUat = {
  error: 'phoneValidation.resendCodeError'
}
